import { TEXT_COLORS } from '@constants/colors.ts';
import { BODY_MD_MD_MEDIUM_STYLES, STYLED_COMPONENTS_TEXT } from '@constants/text.ts';
import styled from 'styled-components';

export const TabItem = styled.div<{ $isSelected: boolean }>`
    color: ${({ $isSelected }) => ($isSelected ? TEXT_COLORS.action : TEXT_COLORS.body)};
    ${BODY_MD_MD_MEDIUM_STYLES};
`;

export const TotalNotifications = styled(STYLED_COMPONENTS_TEXT['body/sm/sm-medium'])`
    color: var(--colors-text-on-disabled, #70768d);
    margin-top: 14px;
    position: absolute;
    top: 0;
    right: 0;
`;

export const TabsWrapper = styled.div`
    margin-bottom: 24px;
    margin-top: 16px;
    position: relative;

    .ant-tabs-tab:not(:first-child) {
        margin: 0 0 0 20px;
    }
`;

export const Assigned = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const TopSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: -16px;
`;
